// Astrea Ops Platform - the signed-in user's token for calls to our own /api functions
// (v7.63, 7 Oct 2026). /api/send-notification and /api/ai-form-assist now refuse anyone
// who is not signed in, so the browser sends its Supabase session token with each call.
import { supabase } from './supabaseClient';

export async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  const h = { 'Content-Type': 'application/json' };
  if (session && session.access_token) h.Authorization = `Bearer ${session.access_token}`;
  return h;
}
